import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b639a2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "nav-bar-title" }
const _hoisted_3 = { class: "nav-bar-name" }
const _hoisted_4 = { class: "top-action-panel" }
const _hoisted_5 = { class: "message-list" }
const _hoisted_6 = { class: "bottom-container" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("发起对话")
const _hoisted_8 = { class: "block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "发起对话中...", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_history_detail_page_subtitle = _resolveComponent("history-detail-page-subtitle")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_yunque_message = _resolveComponent("yunque-message")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_tag_edit = _resolveComponent("tag-edit")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_van_overlay = _resolveComponent("van-overlay")!
  const _component_history_source_dialog = _resolveComponent("history-source-dialog")!
  const _component_van_dialog = _resolveComponent("van-dialog")!
  const _directive_chat_scroll = _resolveDirective("chat-scroll")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_nav_bar, {
        onClickLeft: _ctx.goBack,
        "left-text": "返回",
        "left-arrow": ""
      }, {
        title: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currentHistoryDetail?.feName || _ctx.currentHistoryDetail?.name), 1),
            _createVNode(_component_history_detail_page_subtitle, { detail: _ctx.currentHistoryDetail }, null, 8, ["detail"])
          ])
        ]),
        _: 1
      }, 8, ["onClickLeft"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "top-action",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSourceDialog = true))
        }, "访客来源"),
        _createElementVNode("div", {
          class: "top-action",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editLead && _ctx.editLead(...args)))
        }, "编辑客资"),
        _createElementVNode("div", {
          class: "top-action",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEditTag = true))
        }, "编辑标签")
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (message) => {
          return (_openBlock(), _createBlock(_component_yunque_message, {
            message: message,
            key: message.microtime,
            onOnRecall: _ctx.recallMessage,
            onClick: _ctx.clickHistoryMessage
          }, null, 8, ["message", "onOnRecall", "onClick"]))
        }), 128))
      ], 512), [
        [_directive_chat_scroll, { always: false, smooth: true }]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_van_button, {
          id: "start-btn",
          onClick: _ctx.startCon,
          block: "",
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.showEditTag)
      ? (_openBlock(), _createBlock(_component_tag_edit, {
          key: 0,
          uid: _ctx.currentHistoryDetail.uid,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showEditTag = false))
        }, null, 8, ["uid"]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_overlay, { show: _ctx.showLoadingStartingCon }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_loading, {
              type: "spinner",
              color: "#1989fa"
            }),
            _hoisted_9
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_dialog, {
      show: _ctx.showSourceDialog,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showSourceDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_history_source_dialog, { currentHistoryVisitor: _ctx.currentHistoryDetail }, null, 8, ["currentHistoryVisitor"])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}